import CryptoJS from 'crypto-js';

const crpytoConfig = {
  AES_KEY: CryptoJS.enc.Utf8.parse('1234123412ABCDEF'),
};

/**
 * @description aes加密 Base64
 * @param {string} word 需要加密的字符串
 */
export const cryptoEncryptBase = word => {
  const { AES_KEY } = crpytoConfig;

  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(srcs, AES_KEY, { mode: CryptoJS.mode.ECB, });

  let ciphertextBase64 = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);

  return ciphertextBase64;
};


/**
 * @description aes解密 Base64
 * @param {string} word 需要解密的字符串
 */

export const cryptoDecryptBase = word => {
  const { AES_KEY } = crpytoConfig;

  let ciphertext = CryptoJS.enc.Base64.parse(word);

  let decrypted = CryptoJS.AES.decrypt(
    { ciphertext: ciphertext },
    AES_KEY,
    { mode: CryptoJS.mode.ECB }
  );

  let decryptedText = CryptoJS.enc.Utf8.stringify(decrypted);

  return decryptedText;
}
